export function makeTall2() {
    $("#shoppingcart_hover").fadeIn(200);
    $(".shopping_bag").toggleClass("hover-bag").delay(200);

}